import React from "react";
import { GoogleReCaptchaProvider } from "@google-recaptcha/react";

const CaptchaProvider = ({ children }) => (
  <GoogleReCaptchaProvider
    type="v3"
    siteKey={process.env.REACT_APP_CAPTCHA_KEY}
  >
    {children}
  </GoogleReCaptchaProvider>
);

export default CaptchaProvider;
